<template>
  <v-container dense>
    <v-row justify-center style="align-items:center;" dense>
      <v-col sm="6" cols="12">
        <v-text-field
          color="#00006d"
          v-model="initAddress.line1"
          class="ja-field mx-5"
          :rules="streetRules"
          label="Address Line 1"
        ></v-text-field>
      </v-col>
      <v-col sm="6" cols="12">
        <v-text-field
          color="#00006d"
          v-model="initAddress.line2"
          class="ja-field mx-5"
          label="Address Line 2"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row justify-center style="align-items:center;" dense>
      <v-col sm="4" cols="12">
        <v-text-field
          color="#00006d"
          v-model="initAddress.city"
          :rules="[(v) => !!v || 'City is required']"
          class="ja-field mx-5"
          label="City"
        ></v-text-field>
      </v-col>
      <v-col sm="4" cols="12">
        <v-select
          color="#00006d"
          v-model="initAddress.state"
          :items="stateList"
          :hint="stateHint"
          item-text="name"
          class="ja-field mx-5"
          label="State"
          @change="stateChange"
          return-object
          persistent-hint
        >
        </v-select>
      </v-col>
      <v-col sm="4" cols="12">
        <v-text-field
          color="#00006d"
          type="number"
          v-model.number="initAddress.zipCode"
          :rules="zipRules"
          class="ja-field mx-5"
          label="Zip Code"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import states from '../../../assets/Entities/statesJSON.json';
export default {
  name: 'business-address',
  model: {
    prop: 'address',
    event: 'change'
  },
  props: {
    address: Object,
  },
  data: () => ({
    initAddress: {
      line1: '',
      line2: '',
      city: '',
      state: '',
      zipCode: null
    },
    stateList: states,
    streetRules: [(v) => !!v || 'Street address is required'],
    zipRules: [
      (v) => !!v || 'Zip code is required',
      (v) => (v >= 501 && /^\d{5,5}$/.test(v)) || 'Please enter a valid zip code',
    ],
  }),
  created(){
    this.initAddress = this.address;
  },
  computed: {
    stateHint() {
      if (this.address.state.abbreviation === '' || this.address.state.name === '') {
        return '';
      } else {
        return `${this.address.state.name}, ${this.address.state.abbreviation}`;
      }
    }
  },
  methods: {
    stateChange(event) {
      this.initAddress.state = event;
    },
    resetValidation() {

    },
  },
};
</script>

<style>
@import "/styles/site-styles.scss";
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.container {
  max-width: initial !important;
}
</style>
